export default {
  priv: 'pr_reference',
  overviewTitle: 'Bestanden',
  detailTitle: 'Bestand',
  deleteTitle: 'dit bestand',
  url: '/references/documents',
  apiUrl: '/sitereportlayouts/',
  sortBy: [],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'documents',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'str'
  },
  newRecord: {
    report_layout_type: 3,
    devicegroup_id: 3
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/documents/{id}',
      width: '30%'
    },
    {
      text: 'Bestandsnaam',
      value: 'file.name',
      width: '30%'
    },
    {
      text: 'Grootte',
      value: 'file.size',
      width: '20%',
      filter: 'prettyBytes'
    }
  ]
};
